export class MGVideoElement extends HTMLElement {

    getAttributeValue(key, isBool) {
        if (isBool) {
            const v = this.getAttribute(key)
            if (v === "false") {
                return false
            }
            return this.hasAttribute(key)
        }

        return this.getAttribute(key)
    }

    get url() {
        return this.getAttributeValue("url")
    }

    get autoplay() {
        return this.getAttributeValue("autoplay", true)
    }

    get muted() {
        return this.getAttributeValue("muted", true)
    }

    get fullpage() {
        return this.getAttributeValue("fullpage", true)
    }

    get app() {
        return this.getAttributeValue("app")
    }

    get key() {
        return this.getAttributeValue("key")
    }

    get errorImage() {
        return this.getAttributeValue("errorImage")
    }

    get showErrorMessage() {
        return this.getAttributeValue("showErrorMessage", true)
    }

}
